import { css } from '@emotion/react'

const Styles = ({ colors }) => {
  const { scales: { blue, grayShades } } = colors

  return ({
    containerCurve: css`
      display: flex
    `,
    curveL: css`
      height: 3.125rem;
      width: 50%;
      top: -1.625rem;
      background: ${grayShades[0]};
      position: relative;
      clip-path: ellipse(63% 100% at 44.7% 100%);
      @media (max-width: 767px ) {
        top: -2.25rem;
        clip-path: ellipse(75% 100% at 44.7% 100%);
      }
    `,
    curveR: css`
      height: 3.125rem;
      width: 50%;
      background: linear-gradient(to bottom, ${blue[5]} 152%, ${grayShades[0]} 0%);
      position: relative;
      top: -1.357rem;
      clip-path: ellipse(63% 100% at 56.73% 0%);
      @media (max-width: 767px ) {
        top: -2.757rem;
        clip-path: ellipse(62% 85% at 50.63% 0%);
      }
    `
  })
}

export { Styles }
